import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Card as AntdCard, Card } from 'antd';
import './panel.less';
import numeral from 'numeral';
import { moneyFormat } from '../../common/constants';


export default class DualPanel extends Component {

  render() {
    const {
        translate,
        firstTitle,
        secondTitle,
        skipFirstValueFormat,
        skipSecondValueFormat,
        firstValue,
        secondValue
    } = this.props
    return (
        <Card
        hoverable={true}
        className="panel card-data-loan"
      >
        <div className='panel-subsection-container'>
          <p className='panel-subsection-title'>
            {translate(firstTitle)}
          </p>
        <h1 className='loans-breakdown'>
          {skipFirstValueFormat ? firstValue : numeral(firstValue).format(moneyFormat)}
        </h1>
        </div>
        <div className='panel-subsection-container'>
        <p className='panel-subsection-title'>
            {translate(secondTitle)}
          </p>
        <h1 className='loans-breakdown'>
          {skipSecondValueFormat ? secondValue : numeral(secondValue).format(moneyFormat)}
        </h1>
        </div>
        </Card>
    );
  }
}
